import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeEnhancers } from "../config/envConfig";

import rootReducer from "./reducers";

const middlewares = [thunk];

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const composeEnhancers = compose;

export default createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middlewares)),
);
